var map = {
	"./apple-pie.png": 5744,
	"./baguette.png": 3953,
	"./boiled-egg.png": 8510,
	"./bread.png": 3080,
	"./burger.png": 1505,
	"./burrito.png": 7943,
	"./cake.png": 9657,
	"./cereal.png": 1570,
	"./cheesecake.png": 3214,
	"./chicken-soup.png": 376,
	"./churros.png": 8810,
	"./coffee.png": 1093,
	"./cookie.png": 7213,
	"./croissant.png": 7617,
	"./cupcake.png": 5753,
	"./curry.png": 6865,
	"./donut.png": 4810,
	"./dumplings.png": 1474,
	"./eclair.png": 5844,
	"./egg.png": 1974,
	"./fish-and-chips.png": 1317,
	"./french-fries.png": 5907,
	"./french-toast.png": 5542,
	"./fried-chicken.png": 350,
	"./fried-rice.png": 7538,
	"./gingerbread-man.png": 3624,
	"./hotdog.png": 7253,
	"./ice-cream.png": 7038,
	"./juice.png": 7048,
	"./ketchup.png": 113,
	"./lasagna.png": 8141,
	"./macarons.png": 3579,
	"./marshmallow.png": 2405,
	"./paella.png": 2034,
	"./pancake.png": 3010,
	"./pasta.png": 6673,
	"./pizza-one.png": 295,
	"./pizza.png": 8715,
	"./pudding.png": 1811,
	"./ramen.png": 91,
	"./red-velvet.png": 9466,
	"./rendang.png": 8507,
	"./rice.png": 1665,
	"./salad.png": 5431,
	"./sandwich.png": 7915,
	"./satay.png": 978,
	"./skewer.png": 9596,
	"./spaghetti.png": 9071,
	"./steak.png": 5001,
	"./sushi.png": 8058,
	"./swiss-roll.png": 1276,
	"./taco.png": 5530,
	"./takoyaki.png": 276,
	"./waffle.png": 8056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9169;